import React, { Component } from 'react';
import {connect} from 'react-redux'


const AppUrl = 'https://app.swinity.com/api/creatives';

class SsrBanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      DomId: this.MakeId(10),
      DoApiClick: this.isNullOrUndefined(props.doApiClick) ? true : props.doApiClick,
      ZoneId: this.isNullOrUndefined(props.ZoneId) ? "" : props.ZoneId,
      Class: this.isNullOrUndefined(props.className) ? "" : props.className,

    };
  }

  componentDidMount() {

  }


  handleClick(e,cre) {
    try {
      if(typeof window !== "undefined" && typeof window.ga !== "undefined") {
        window.ga('send', 'event', 'Banner', 'Click', cre.Click.Name);
      }
      if(typeof window !== "undefined" && typeof window.gtag !== "undefined") {
        window.gtag('event', 'view_promotion', [
          {"creative_name": cre.Creative.Title, "creative_slot": cre.Zone.Name + " - " + window.location.hostname, "id": cre.Click.Guid, "name": cre.Click.Name}
        ]);
      }
    } catch(ex) {}
    if(this.state.DoApiClick) {
      this.apiClick(cre.Click.Guid)
    }
  }


  apiClick(id) {
    let headers = {
      "X-Alt-Referer": window.location.href,
      "Content-type": "application/json"
    };
    if (!this.isNullOrEmpty(this.props.AnonymousId)) {
      headers["X-Alt-AnonymousId"] = this.props.AnonymousId;
    } //Do Not Need Any Resp, Etc.. Log On Error Thats It
    fetch(`${AppUrl}/click`, {headers: headers, method: "POST", body: JSON.stringify({Guid: id})})
      .catch((ex) => {
        console.log("Error in click call swbanner",ex);
      });
  }

  load() {

  }

  renderBanners() {
    let resp = null; //Render NOTHING
    try {
      let bans = this.props.Ads[this.props.ZoneId].ApiResult.Result;
      if(!this.isNullOrUndefined(bans) && bans.length>0) {
        resp = bans.map((v,i) =>{
          let type = "banner";
          if(v.Creative.Code == "ADVERTISEHERE") {
            type = "ad";
          }
          return (
            <React.Fragment key={`${this.state.DomId}-${v.Creative.Code}-${i}`}>
              {type=="banner" &&
              <div className={this.props.className}><a onClick={(e) => {this.handleClick(e,v)}} href={v.Creative.TargetUrl} target={"_blank"} title={v.Creative.Title} className={this.props.className} rel={v.Rel}>
                <img src={v.Creative.Url} alt={v.Creative.Title} className={this.props.className}/>
              </a></div>
              }
              {type=="ad" &&
              <div className={this.props.className}>
                {this.props.children}
              </div>
              }
            </React.Fragment>
          );
        });
      }
    } catch(ex) {
    }
    return resp;
  }


  render() {


    if(this.isNullOrUndefined(this.props.Ads[this.props.ZoneId])) {
      return null;
    }
    let rec = this.props.Ads[this.props.ZoneId];


    if(!rec.Loaded) {
      return null;
    }

    return this.renderBanners();
  }

  componentDidUpdate() {

  }


  //Utils Here
  isNullOrUndefined(val) {
    return val === null || typeof val === "undefined";
  }
  isNullOrEmpty(obj) {
    if(typeof obj === "undefined") { return true;}
    if(obj === null) { return true;}
    if(typeof obj === "string") { return obj === "" }
    return false;
  }
  isMoreThenZero(tInt) {
    if(this.isNullOrUndefined(tInt)) return false;
    if(typeof tInt === "string") {
      let cInt = parseInt(tInt,10);
      if(isNaN(cInt)) {
        return false;
      }
      return cInt > 0;
    } else {
      if(typeof tInt === "number") {
        return tInt > 0;
      }
    }
    return false;
  }
  MakeId(length) {
    let result = '';
    let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let charactersLength = characters.length;
    for ( let i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
}

const mapStateToProps = (state) => {
  return {
    Ads: state.Ads.SSRAds
  }
};

export default connect(mapStateToProps)(SsrBanner)


